module.exports = __webpack_public_path__ + "static/img/caseImg5.c12dcf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg5.jpg
// module id = YY9X
// module chunks = 0